<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  import { initDetail, record, save, onPrint, downloadTracciabilitaReport } from "./transport-document.store";
  import type { ITransportDocument } from "../../entities/transport-document";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import CustomerDropdown from "../../components/Business/CustomerDropdown.svelte";
  import CarrierDropdown from "../../components/Business/CarrierDropdown.svelte";
  import DateInputString from "../../components/Form/Fields/DateInputString.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import TransportDocumentSlaughterItemsFragment from "./TransportDocumentSlaughterItemsFragment.svelte";
  import TransportDocumentSectionItemsFragment from "./TransportDocumentSectionItemsFragment.svelte";
  import Button from "../../components/Button.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { CustomerService } from "../../services/customer.service";
  import { get } from "svelte/store";
  import CustomerAddressDropdown from "../../components/Business/CustomerAddressDropdown.svelte";
  import Switch from "../../components/Form/Fields/Switch.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import type { ICustomer } from "../../entities/customer";
  import TransportDocumentLabelsFragment from "./TransportDocumentLabelsFragment.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit =
    $record != null &&
    $record.documentDate != "" &&
    $record.customerId != null &&
    $record.clfPurposeId != null &&
    $record.destinationId != null &&
    $record.destinationAddressId != null &&
    $record.clfPaymentTypeId != null &&
    $record.clfPaymentStatusId != null;

  $: canEdit = $record != null && $record.oid == 0;

  enum TransportDocumentPage {
    General = 1,
    Items,
    Labels,
  }

  let currentTab: TransportDocumentPage = TransportDocumentPage.General;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<ITransportDocument> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/transport-document/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/transport-document`);
  }

  function ddtNumber(ddt: ITransportDocument) {
    if (!ddt || ddt.oid == 0) return "da assegnare";
    return ddt.yearlyNumber + ddt.phaseCode + " / " + ddt.year;
  }

  /*
	async function onDstCustomerSelected(evt: CustomEvent<IDropdownItem>) {
		try {
			let r = get(record);
			if (r == null) return;
			let customerId = evt.detail.oid;
			if (!customerId) return;
			let cust = await CustomerService.getCustomerAddresses(customerId);
			let defaultAddressId: number | null = null;
			if (cust != null && cust.payload != null) {
				let ids = cust.payload
					.filter((x) => x.headquarters == 1)
					.map((x) => x.oid);
				if (!!ids && ids.length > 0) defaultAddressId = ids[0];
			}

			r.destinationAddressId = defaultAddressId!;
			record.set(r);
		} catch (err) {
			onDstCustomerClear(null!);
		}
	}
	async function onDstCustomerClear(_evt: CustomEvent<any>) {
		let r = get(record);
		if (r == null) return;
		r.destinationAddressId = null!;
		record.set(r);
	}
  */

  async function onDstCustomerSelected(evt: CustomEvent<IDropdownItem>) {
    if (evt.detail == null) return;

    let customerId = evt.detail.oid;
    let _curr = get(record);

    if (!!_curr) {
      let _resp = await CustomerService.fetchCustomer(customerId);
      let customer: ICustomer = _resp.payload;

      if (!!customer && !!customer.clfPaymentTypeId) {
        record.set({ ..._curr, clfPaymentTypeId: customer.clfPaymentTypeId });
      } else {
        record.set({ ..._curr, clfPaymentTypeId: undefined! });
      }
    }
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  <div class="ddt-main-controls">
    <div class="ddt-tabs">
      <Tabs>
        <Tab
          label="Generale"
          active={currentTab == TransportDocumentPage.General}
          on:click={(_) => {
            currentTab = TransportDocumentPage.General;
          }}
        />

        {#if !isNew}
          <Tab
            label="Articoli"
            active={currentTab == TransportDocumentPage.Items}
            on:click={(_) => {
              currentTab = TransportDocumentPage.Items;
            }}
          />
        {/if}

        {#if !isNew && $record != null && ($record.phaseCode == "S" || $record?.phaseCode == "T")}
          <Tab
            label="Etichette"
            active={currentTab == TransportDocumentPage.Labels}
            on:click={(_) => {
              currentTab = TransportDocumentPage.Labels;
            }}
          />
        {/if}
      </Tabs>
    </div>
    {#if currentTab == TransportDocumentPage.General}
      <div class="ddt-print">
        <Button klass="is-warning" disabled={isNew} on:click={onPrint}>Stampa</Button>
      </div>
    {/if}
  </div>

  {#if $record}
    <!-- GENERAL -->
    {#if currentTab == TransportDocumentPage.General}
      <div class="columns">
        <div class="column is-12">
          <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
            {#key $record}
              <div class="columns">
                <div class="column is-4">
                  <FormField>
                    <Input name="Numero DDT" placeholder="" disabled={true} required={false} value={ddtNumber($record)} />
                  </FormField>
                </div>
                <div class="column is-4">
                  <FormField>
                    <!-- <DateInputString name="Data" placeholder="" required={true} disabled={!canEdit} bind:value={$record.documentDate} /> -->
                    <DateInputString name="Data" placeholder="" required={true} disabled={false} bind:value={$record.documentDate} />
                  </FormField>
                </div>
                <div class="column is-4">
                  <FormField>
                    <Switch name="Pesi" bind:value={$record.weights} />
                  </FormField>
                </div>
              </div>
            {/key}

            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <CustomerDropdown name="Cliente" required={true} bind:value={$record.customerId} />
                </FormField>
              </div>
              <div class="column is-6">
                <FormField>
                  <ClfDropdown name="Scopo" placeholder="" schema="PURPOSEXXX" required={true} bind:value={$record.clfPurposeId} />
                </FormField>
              </div>
            </div>

            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <CustomerDropdown name="Destinazione" required={true} bind:value={$record.destinationId} on:select={onDstCustomerSelected} />
                </FormField>
              </div>
              <div class="column is-6">
                {#key $record.destinationId}
                  <FormField>
                    <CustomerAddressDropdown
                      name="Indirizzo Destinazione"
                      required={true}
                      clearVisible={false}
                      customerId={$record.destinationId}
                      bind:value={$record.destinationAddressId}
                    />
                  </FormField>
                {/key}
              </div>
            </div>

            <div class="columns">
              <div class="column is-3">
                <FormField>
                  <ClfDropdown name="Trasporto a mezzo" placeholder="" schema="DDTTRSMEAN" required={true} bind:value={$record.clfTransportMeansId} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <ClfDropdown name="Porto" placeholder="" schema="DDTPORTXXX" required={true} bind:value={$record.clfPortId} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <ClfDropdown name="Causale" placeholder="" schema="DDTREASONX" required={true} bind:value={$record.clfReasonId} />
                </FormField>
              </div>
            </div>

            <div class="columns">
              <div class="column is-6">
                <ClfDropdown name="Tipo Pagamento" placeholder="" schema="PAYMENTTYP" required={true} bind:value={$record.clfPaymentTypeId} />
              </div>

              <div class="column is-6">
                <ClfDropdown name="Stato Pagamento" placeholder="" schema="PAYMENTSTS" required={true} bind:value={$record.clfPaymentStatusId} />
              </div>
            </div>

            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <CarrierDropdown name="Vettore" required={false} clearVisible={true} bind:value={$record.carrierId} />
                </FormField>
              </div>
              <div class="column is-6">
                <FormField>
                  <DateInput name="Inizio trasporto" required={false} calendarType="datetime" bind:value={$record.startTransport} />
                </FormField>
              </div>
            </div>

            <div class="columns">
              <div class="column is-3">
                <FormField>
                  <NumberInput name="Differenza Teste" placeholder="" required={false} bind:value={$record.deltaTeste} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <NumberInput name="Differenza Frattaglie" placeholder="" required={false} bind:value={$record.deltaFrattaglie} />
                </FormField>
              </div>
              <div class="column is-3">
                <FormField>
                  <NumberInput name="Differenza Piedini" placeholder="" required={false} bind:value={$record.deltaPiedini} />
                </FormField>
              </div>
            </div>

            <div class="columns">
              <div class="column is-6">
                <FormField>
                  <Textarea name="Note in DDT" placeholder="note" required={false} bind:value={$record.visibleNotes} />
                </FormField>
              </div>
              <div class="column is-6">
                <FormField>
                  <Textarea name="Note interne" placeholder="note" required={false} bind:value={$record.notes} />
                </FormField>
              </div>
            </div>

            <!--
            <div slot="other_buttons" class="control">
              {#key $record.customerVatNumber}
                {#if !isNew && $record.customerVatNumber != ""}
                  <Button klass="is-warning" on:click={(_) => downloadTracciabilitaReport()}>Dichiarazione Tracciabilità</Button>
                {/if}
              {/key}
            </div>
            -->
            <div slot="other_buttons" class="control">
              {#if !isNew && $record.phaseCode == "M"}
                <Button klass="is-warning" on:click={(_) => downloadTracciabilitaReport()}>Dichiarazione Tracciabilità</Button>
              {/if}
            </div>
          </FormLayout>
        </div>
      </div>
    {/if}

    <!-- ITEMS -->
    {#if currentTab == TransportDocumentPage.Items}
      {#if $record.phaseCode == "M"}
        <TransportDocumentSlaughterItemsFragment transportDocumentId={$record.oid} withWeights={$record.weights == 1} />
      {:else}
        <TransportDocumentSectionItemsFragment transportDocumentId={$record.oid} withWeights={$record.weights == 1} phaseCode={$record.phaseCode} />
      {/if}
    {/if}

    <!-- LABELS -->
    {#if currentTab == TransportDocumentPage.Labels}
      <TransportDocumentLabelsFragment transportDocumentId={$record.oid} />
    {/if}
  {/if}
</MainLayout>

<style>
  .ddt-main-controls {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .ddt-main-controls .ddt-tabs {
    flex: 1;
  }
  .ddt-main-controls .ddt-print {
    margin-left: 1rem;
  }
</style>
